import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import { bindActionCreators as bindScopedActionCreators } from 'multireducer';
import { compose } from 'redux';
import { connect } from 'react-redux';
import AlignmentList from "../components/AlignmentList/index.js";
import WithAlignmentSet from "../components/WithAlignmentSet.js";
import { getAlignedOutcomes, getLaunchContexts, makeIsOpen } from "../store/alignments/selectors.js";
import * as contextActions from "../store/context/actions.js";
import * as alignmentActions from "../store/alignments/actions.js";
import * as outcomePickerActions from "../store/OutcomePicker/actions.js";
import ConnectedOutcomePickerModal from "./ConnectedOutcomePickerModal.js";
import ConnectedOutcomeTray from "./ConnectedOutcomeTray.js";
var mapStateToProps = function mapStateToProps(state, ownProps) {
  var scope = ownProps.scope,
    pickerType = ownProps.pickerType;
  return {
    addModal: pickerType === 'tray' ? ConnectedOutcomeTray : ConnectedOutcomePickerModal,
    alignedOutcomes: getAlignedOutcomes(state, scope),
    launchContext: getLaunchContexts(state, scope),
    isOpen: makeIsOpen(state, scope)
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  var scope = ownProps.scope;
  return _objectSpread(_objectSpread(_objectSpread({}, bindScopedActionCreators(contextActions, dispatch)), bindScopedActionCreators(alignmentActions, dispatch, scope)), bindScopedActionCreators(outcomePickerActions, dispatch, scope));
};
var ConnectedAlignmentList = compose(connect(mapStateToProps, mapDispatchToProps), WithAlignmentSet)(AlignmentList);
export default ConnectedAlignmentList;